import { useEffect, useState } from 'react'
import { HiArrowUp } from 'react-icons/hi2'

export const ScrollUpButton = () => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handler = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop
      setVisible(scrollTop > 200)
    }
    handler()
    window.addEventListener('scroll', handler, { passive: true })
    window.addEventListener('resize', handler)
    return () => {
      window.removeEventListener('scroll', handler)
      window.removeEventListener('resize', handler)
    }
  }, [])

  if (!visible) return null

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-white border border-gray-200 shadow-lg text-gray-700 hover:bg-gray-50 transition-colors"
      aria-label="Наверх"
    >
      <HiArrowUp className="w-5 h-5 mx-auto" />
    </button>
  )
}
